import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import useURLQuery from 'hooks/useURLQuery';

import styles from './PaymentError.module.scss';

function PaymentError({ className }: { className?: string }): JSX.Element {
  const { t } = useTranslation(['checkout']);
  const { error } = useURLQuery();
  const hasError = error === 'true';

  return (
    <>
      {hasError && (
        <div
          className={classNames(styles.errorMessage, styles.error, className)}
        >
          {t('GENERIC_PAYMENT_ERROR_MESSAGE')}
        </div>
      )}
    </>
  );
}

export default PaymentError;
